import React from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {
  return (
    <div 
      className="relative w-full min-h-[320px] md:min-h-[400px] overflow-hidden"
      style={{
        backgroundImage: 'url(/Banner/image.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-black/60 md:bg-black/40" />
      <div className="container mx-auto px-4 h-full relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between h-full min-h-[320px] md:min-h-[400px] py-10 md:py-6 gap-4 md:gap-8">
          <div className="max-w-2xl text-white text-center md:text-left mb-4 md:mb-0">
            <h2 className="text-base sm:text-lg md:text-xl lg:text-4xl xl:text-5xl font-bold mb-2 md:mb-4 lg:mb-8 leading-tight drop-shadow-lg">
             Autos nuevos y usados en Argentina
            </h2>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white mb-1 md:mb-2 drop-shadow-md font-medium">
             Financiación disponible y entrega rápida
            </p>
            <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl text-white/90 drop-shadow-md">
             Ventas B2B (de empresa a cliente final)
            </p>
          </div>

          <Link
            to="/catalogo"
            className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-sky-600 to-sky-700 hover:from-sky-700 hover:to-sky-800 text-white font-bold py-3 sm:py-4 px-4 sm:px-6 lg:px-8 rounded-lg sm:rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-lg text-sm sm:text-base md:text-xl whitespace-nowrap border-2 border-white/20"
          >
            <svg 
              className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex-shrink-0" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
              />
            </svg>
            <span className="text-xs sm:text-sm md:text-base">VER AUTOS</span>
            <span className="text-xs sm:text-sm md:text-base hidden md:inline"> DISPONIBLES</span>
            <svg 
              className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex-shrink-0" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Banner;
